<template>
	<div class="container_head ">
			<div class="card">
				<div class="title">填写用户信息</div>
				<van-popup v-model:show="showPicker" round position='bottom'>
					<van-picker
						show-toolbar
						title="证件类型"
						:columns="columns"
						@confirm="onConfirm"
						@cancel="onCancel"
					>
					</van-picker>
				</van-popup>
				<van-field v-model="name" name="trueName" input-align="right" label="姓名" placeholder="请输入真实姓名"/>
				<van-field v-model="tel" type="tel" input-align="right" label="手机号" placeholder="请输入手机号" name="phone" />
				<van-cell title="证件类型" is-link :value="zjlxname" @click="showPicker = true"/>
				<van-field v-model="card" name="cardId" input-align="right" label="证件号码" placeholder="请输入证件号码"/>
			</div>
			<div class="tip" v-if="identity==20">*信息认证审核中，请耐心等待或重新申请！</div>
			<div class="tip" v-else>*请如实填写信息，以便正常使用平台服务</div>
			<a style="margin-left:25px" class="xiazai disac" download="业主认证及操作导则" href="./业主认证及操作导则.pdf">
				<span class="tip2">《业主认证及操作导则》</span>
			</a>
			<div style="margin: 16px 30px;">
				<van-button round block @click="onSubmit" type="info" native-type="submit" class="btnorange">下一步</van-button>
			</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		Form,
		Cascader
	} from 'vant';
	Vue.use(Form);
	Vue.use(Cascader);
	import {
		mapState,
		mapMutations
	} from "vuex";
	export default {
		data() {
			return {
				name: '',
				tel: '',
				card: '',
				zjlxname:'',
				zjlxid:'',
				showPicker:false,
				columns:[
				{
					text:'身份证',
					value:'1'
				},{
					text:'港澳台身份证',
					value:'2'
				},{
					text:'护照',
					value:'3'
				},{
					text:'军官证（士兵证）',
					value:'5'
				},]
				/* name: '黄海涛',
				tel: '18795905631',
				card: '320281199607046772', */
			};
		},
		computed: {
			...mapState(["identity"]),
		},
		mounted() {},
		methods: {
			...mapMutations(["changeIdentity"]),
			validator(val) {
				return /^1(3|4|5|7|8)\d{9}$/.test(val);
			},
			validator2(val) {
				return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(val);
			},
			goxz(){

			},
			onConfirm(value){
				this.showPicker = false
				this.zjlxname = value.text
				this.zjlxid = value.value
			},
			onCancel(){
				this.showPicker = false
			},
			checkPhone(value) {
				var reg = /^1[3456789]\d{9}$/; //验证手机号
				if(reg.test(value)){
					return { valid: true }; //验证正确返回valid:true
				}else{
					return { valid: false, msg: "手机号格式错误" }; // 验证错误 返回valid:false;
				}
			},
			IdentityCodeValid(code) { 
				var city={11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",21:"辽宁",22:"吉林",23:"黑龙江 ",31:"上海",32:"江苏",33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",41:"河南",42:"湖北 ",43:"湖南",44:"广东",45:"广西",46:"海南",50:"重庆",51:"四川",52:"贵州",53:"云南",54:"西藏 ",61:"陕西",62:"甘肃",63:"青海",64:"宁夏",65:"新疆",71:"台湾",81:"香港",82:"澳门",91:"国外 "};
				var tip = "";
				var pass= true;
				if(code.length!=15&&code.length!=18){
					tip = "身份证号位数错误";
					pass = false;
			}else if(!code ||!/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/.test(code)){
					tip = "身份证号格式错误";
					pass = false;
				}else if(!city[code.substr(0,2)]){
					tip = "地址编码错误";
					pass = false;
				} else{
					//18位身份证需要验证最后一位校验位
					if(code.length == 18){
						code = code.split('');
						//∑(ai×Wi)(mod 11)
						//加权因子
						var factor = [ 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ];
						//校验位
						var parity = [ 1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2 ];
						var sum = 0;
						var ai = 0;
						var wi = 0;
						for (var i = 0; i < 17; i++)
						{
							ai = code[i];
							wi = factor[i];
							sum += ai * wi;
						}
						var last = parity[sum % 11];
						if(parity[sum % 11] != code[17]){
							tip = "校验位错误";
							pass =false;
						}
					}
				}
				if(!pass) this.$toast.fail(tip);
				return pass;
			},
			onSubmit() {
				if(this.name == ''){
					this.$toast.fail('姓名未填写')
				}else if(this.tel == ''){
					this.$toast.fail('手机号未填写')
				}else if(this.zjlxname == ''){
					this.$toast.fail('证件类型未选')
				}else{
					if(!this.checkPhone(this.tel).valid){
						this.$toast.fail('手机号格式错误')
					}else if((this.zjlxid == '1' && this.IdentityCodeValid(this.card)) || (this.zjlxid != '1' && this.card !='')){
						var val = {
								trueName:this.name,
								phone:this.tel,
								cardId:this.card,
								cardType:this.zjlxid
							}
							this.$router.push({
								path:'/bdfw',
								query:val
							});
					}else{
						this.$toast.fail('证件号错误')
					}
				} 
			},

		}
	};
</script>

<style lang="less" scoped>
	.flexcenter {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.card {
		margin: 15px 20px;
		background-color: #fff;
		border-radius: 10px;
		padding: 10px 15px;
	}
	.xiazai{
		margin-top: 10px;
	}
	.xieyi{
        height: 50px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        position: fixed;
        bottom: 0;
        .tongyi{
            color: #fff !important;
            background: #28aff6 !important;
        }
        .hui{
            color: #999999;
            background: #f0f0f0;
        }
        button{
            outline: none;
            border: none;
            border-radius: 5px;
            height: 35px;
            width: 25%;
            color: white;
            font-size: 18px;
        }
    }
	.title {
		color: #ffad0e;
		font-size: 18px;
		text-align: center;
		margin: 5px 0 10px;
		font-weight: bold;
	}

	.tip {
		color: #ffa5a5;
		font-size: 12px;
		padding: 0px 5px 0 25px;
	}
	.tip2 {
		color: #28aff6;
		font-size: 12px;
		padding: 15px 0px 1px 0px;
		border-bottom: 1px solid #28aff6;
	}
	/deep/.van-field--error .van-field__control::placeholder {
		color: #ccc;
	}
</style>
